import {Observable, Subject} from 'rxjs';
import {IConfigGlobal} from './entities/config.global';
import {IConfigIndividual} from './entities/config.individual';
import {ToastRef} from './toast-ref';

/**
 * Everything a toast needs to launch
 */
export class ToastPackage<ConfigPayload = any> {
  private _onTap = new Subject<void>();
  private _onAction = new Subject<any>();

  constructor(
    public toastId: number,
    public config: IConfigIndividual<ConfigPayload> & IConfigGlobal,
    public message?: string,
    public title?: string,
    public toastType?: string,
    public toastRef?: ToastRef<any>
  ) {
    this.toastRef.afterClosed().subscribe(() => {
      this._onAction.complete();
      this._onTap.complete();
    });
  }

  /** Fired on click */
  triggerTap(): void {
    this._onTap.next();
    if (this.config.tapToDismiss) {
      this._onTap.complete();
    }
  }

  onTap(): Observable<void> {
    return this._onTap.asObservable();
  }

  /** available for use in custom toast */
  triggerAction(action?: any): void {
    this._onAction.next(action);
  }

  onAction(): Observable<void> {
    return this._onAction.asObservable();
  }
}

/** @deprecated use GlobalConfig */
export interface GlobalToastrConfig extends IConfigGlobal {}

/** @deprecated use IndividualConfig */
export interface IndividualToastrConfig extends IConfigIndividual {}

/** @deprecated use IndividualConfig */
export interface ToastrConfig extends IConfigIndividual {}
